import { render, staticRenderFns } from "./CustomEmailPreview.vue?vue&type=template&id=f27485fc&scoped=true&"
import script from "./CustomEmailPreview.vue?vue&type=script&lang=js&"
export * from "./CustomEmailPreview.vue?vue&type=script&lang=js&"
import style0 from "./CustomEmailPreview.vue?vue&type=style&index=0&id=f27485fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27485fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDivider,VFlex,VImg,VLayout})
